var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEdgeVisible)?_c('g',_vm._g(_vm._b({key:_vm.id,ref:"edgeEl",class:_vm.edgeWrapperClasses},'g',_vm.edgeWrapperProps,false),_vm.edgeWrapperListeners),[_c('VNodes',{attrs:{"nodes":_vm.EdgeComponent}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }